import Http from '@/services/http';
import { AppConfiguration } from 'sigma-mappings';
import store from '../store';

const configUrl = '/ParametroSistema';

export default {
  requestConfiguration() {
    const http = new Http();
    return http.get(configUrl).then((response) => {
      const config = new AppConfiguration(response.data);
      store.dispatch('setConfiguration', config);
    }).catch((error) => {
      store.dispatch('setErrorGettingConfiguration');
      return Promise.reject(error);
    });
  },
  refreshConfiguration() {
    this.requestConfiguration();
  },
};
